<script setup>
import PageTitleSection from '@/components/PageTitleSection.vue'
import { useFixturesStore } from '@/stores/fixtures'
import { safeTranslate } from '@/helpers'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'

const fixtures = useFixturesStore()
const { getSport, getCompetitionsByRegion } = storeToRefs(fixtures)

const route = useRoute()
const { t, te } = useI18n()
const si = computed(() => route.params.sportId)  
const ri = computed(() => route.params.regionId) 

const region = computed(() => {
  const regions = getCompetitionsByRegion.value?.(si.value) || []
  return regions.find(r => String(r.ri) === String(ri.value))
})

const competitions = computed(() => region.value?.competitions || [])

const regionTranslation = (region) => { 
  return safeTranslate('regions', region.ri, t, te , region.rn)
}
</script>

<template>
  <div class="flex w-full">
    <div class="flex-1">
      <PageTitleSection
        :title="regionTranslation(region) || (getSport(si)?.sn ?? '')"
      />

      <ul class="list-none divide-y divide-neutral-600/50">
        <li v-for="c in competitions" :key="c.ci">
          <RouterLink
            :to="`/ps/${si}/l/${ri}/${c.ci}`"
            class="py-3 px-4 flex justify-between hover:bg-neutral-600/30 cursor-pointer"
          >
            <p class="text-[13px] text-white">{{ c?.cn }}</p>

            <div
              class="text-[11px] bg-[var(--color-primary5)] font-bold px-0.5 rounded-sm flex items-center h-3"
            >
              {{ c.count }} &raquo;
            </div>
          </RouterLink>
        </li>
      </ul>
    </div>
  </div>
</template>
